import { memo, useContext } from 'react';

import { Image } from '@/shared/ui';

import { BlockTitle } from '@/components/old';

import ModalContext from '../../../contexts/Modal/ModalContext';
import { Button } from '../../Button';
import { ModalBorderTopColor, ModalConstructor } from '../ModalConstructor';

import './InsuranceOrderRenewalAlert.scss';

export interface InsuranceOrderRenewalAlertProps {
  onStay?: () => void;
  onLeave: () => void;
}

export const InsuranceOrderRenewalAlertAlert = memo<InsuranceOrderRenewalAlertProps>(function ({ onStay, onLeave }) {
  const { toggleModal } = useContext(ModalContext);

  return (
    <ModalConstructor modalBorderTopColor={ModalBorderTopColor.yellow}>
      <div className="insurance-order-renewal-alert">
        <div className="insurance-order-renewal-alert__title">
          <Image src="/images/attention_grey.svg" alt="attention grey" />
          <BlockTitle withoutBaseStyles>Увага! Ви впевнені, що хочете скасувати індивідуальну оферту?</BlockTitle>
        </div>

        <div className="insurance-order-renewal-alert__buttons-box">
          <Button
            onClick={(): void => {
              onStay && onStay();
              toggleModal(false);
            }}
          >
            Скасувати
          </Button>

          <Button
            outline
            onClick={(): void => {
              onLeave();
              toggleModal(false);
            }}
          >
            Підтвердити
          </Button>
        </div>
      </div>
    </ModalConstructor>
  );
});
